import { render, staticRenderFns } from "./EditCollaboratorForm.vue?vue&type=template&id=c9620a6c&"
import script from "./EditCollaboratorForm.vue?vue&type=script&lang=js&"
export * from "./EditCollaboratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports